module.exports = __webpack_public_path__ + "static/media/selfAcrylic.1ed8da00.png";